export default __webpack_public_path__ + "static/media/Strugani 5.a55a2d13.jpg";